import { useUser } from '@tbitop/authentication';
import { Link, MobilePage } from '@tbitop/mobile-app';
import type { IndividuelleAufgabeFormValues } from '@tbitop/ui';
import { IndividuelleAufgabeForm, useNotifications } from '@tbitop/ui';
import { House } from 'phosphor-react';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useAufgabeErstellenMutation } from '../infrastructure/graphql/AufgabeErstellenMutation';
import { useBearbeiterQuery } from '../infrastructure/graphql/BearbeiterQuery';
import { useVerfuegbareObjekteQuery } from '../infrastructure/graphql/VerfuegbareObjekteQuery';

export const IndividuelleAufgabeErstellen = () => {
  const navigate = useNavigate();
  const notify = useNotifications();
  const user = useUser();
  const { data: objekte } = useVerfuegbareObjekteQuery();
  const { data: bearbeiterListe } = useBearbeiterQuery();
  const { execute, loading: submitting } = useAufgabeErstellenMutation();

  const currentBearbeiterId = useMemo(
    () => bearbeiterListe.find(b => b.email === user?.email)?.id,
    [bearbeiterListe, user?.email],
  );

  const handleSubmit = useCallback(async (values: IndividuelleAufgabeFormValues) => {
    const result = await execute({ ...values, bearbeiter: currentBearbeiterId });
    if (!result.errors) {
      notify.success('Individuelle Aufgabe erstellt.');
      navigate('/objekte');
    }
  }, [execute, navigate, notify, currentBearbeiterId]);

  return (
    <MobilePage title="Individuelle Aufgabe erstellen">
      <div className="sticky top-0 z-50 bg-tds-color-organizer-90 pb-300">
        <div className="flex mb-2">
          <Link href="/objekte" className="flex items-center">
            <House size={22} />
          </Link>
        </div>
      </div>

      <div className="p-200">
        <IndividuelleAufgabeForm
          objekte={objekte}
          onSubmit={handleSubmit}
          submitting={submitting}
        />
      </div>
    </MobilePage>
  );
};
